import React from "react";
import { CircularProgress, Grid } from "@mui/material";

interface Props {
  couleur?: "primary" | "secondary" | "inherit";
  taille?: number;
}

const Spinner: React.FC<Props> = ({ couleur = "primary", taille = 80 }) => {
  return (
    <Grid container justifyContent="center">
      <CircularProgress color={couleur} size={taille} />
    </Grid>
  );
};

export default Spinner;
